"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserToSimpleDriver = transformUserToSimpleDriver;
function transformUserToSimpleDriver(user) {
    const driverFields = user.driversCompany || user.driver;
    return {
        _id: user._id,
        fullName: `${user.firstName} ${user.lastName}`.trim(),
        email: user.email,
        isDriver: !!user.driver,
        isCompany: !!user.driversCompany,
        isCompanyDriver: !!user.driver?.driversCompanyUserId,
        score: driverFields?.score?.totalScore ?? 0,
        hiredAt: driverFields?.hiredAt,
        activeAt: driverFields?.activeAt,
        declinedAt: driverFields?.declinedAt,
        lastLoginAt: user.lastLoginAt,
        town: driverFields?.town ?? "",
        managementNote: driverFields?.managementNote ?? "",
        willingToSleepoverCount: user.driver?.willingToSleepoverCount ?? 1,
        position: driverFields?.position,
        companyUserId: user.driver?.driversCompanyUserId,
        amountOfDrivers: user.transporterInfo?.companyDriversIds?.length ?? 0,
        isSuitableForLuxury: user.driver?.isSuitableForLuxury ?? false,
        isSuitableForPool: user.driver?.isSuitableForPool ?? false,
        canSpeakEnglish: user.driver?.canSpeakEnglish ?? false,
        willingToDoLite: driverFields?.willingToDoLite ?? true,
        isTCPDriver: user.driver?.isTCPDriver ?? false,
        willingToRentVehicleTypes: driverFields?.willingToRentVehicleTypes ?? [],
    };
}
//# sourceMappingURL=transformUserToSimpleDriver.js.map